import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import CheckoutForm from './CheckoutForm';
import { loadStripe } from '@stripe/stripe-js';
import ScenarioCheckout from './ScenarioCheckout';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

function StripeCheckoutWrapper() {
  const appearance = {
    theme: 'night',
  };

  const options = {
    appearance,
  };

  return (
    <Elements stripe={stripePromise} options={options}>
        <ScenarioCheckout/>
    </Elements>
  );
}
export default StripeCheckoutWrapper;